import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AIMainComponent } from 'app/components/sections/ai/main/main.component';

export const aiAppRoutes : Routes = [
    {
        path: 'ai',
        component: AIMainComponent,
    },
];

@NgModule({
  imports: [
      RouterModule.forRoot(aiAppRoutes)
  ],
  exports: [RouterModule]
})
export class AppAIRouterModule { }
